import Base from './Base'
import gsap from 'gsap'

import { evt, utils, store } from '@/core'

const { qs, qsa, isInViewportDom } = utils
const { dom, bounds } = store

import { lenis } from '../app'

export default class extends Base {
	onEnter() {
		super.onEnter()
	}

	onLeave() {
		super.onLeave()
	}

	onEnterCompleted() {
		super.onEnterCompleted()
		let footer = document.querySelector('.footer')
		let mask = document.querySelector('.bgMaskProp')

		lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
           if( utils.isInViewportDom(footer,0) ){

			mask.classList.add('sticky')
		   }else{
			mask.classList.remove('sticky')
		   }
        })

		this._initCountItems()

		window.addEventListener('scroll', e=>{
			const countItems = document.querySelectorAll("[data-count]");
			countItems.forEach((item) => {
				if (!item.classList.contains("done") && isInViewportDom(item, 0)) {
					item.classList.add("done");
					const data = {
						from: 1,
						to: Number(item.getAttribute("data-count")),
					};
					const hasPoint = `${data.to}`.includes(".");
					data.value = data.from;
					gsap.fromTo(
						data,
						{ value: data.from },
						{
							duration: 3,
							value: data.to,
							snap: { value: hasPoint ? 0.1 : 1 },
							ease: "Power4.easeOut",
							onUpdate: () => {
								const value = hasPoint ? data.value.toFixed(1) : data.value;
								item.innerHTML = item.innerHTML = value;
								item.setAttribute("data-current", value);
							},
							onComplete:() =>{
								item.innerHTML = item.getAttribute("data-str")
							}
						}
					);
				}
			});
		})
	}

	onLeaveCompleted() {
		super.onLeaveCompleted()
	}
	
	_initCountItems() {
		Array.from(document.querySelectorAll(".number-counter")).forEach(
			(item) => {
				if (!item.classList.contains("inited")) {
					const strong = item.querySelector("strong");
					const str = strong.innerHTML
					const numberStr = str.match(/\d/g).join("")
					const number = Number(numberStr);
					strong.innerHTML = `<strong data-count="${number}" data-str="${str}">${0}</strong>`;
					// const hasPercent = strong.innerHTML.includes("%");
					// const hasPoint = `${number}`.includes(".");
					// strong.innerHTML = `<span data-count="${number}">${
					// 	hasPoint ? "0.0" : 0
					// }</span>`;
					// if (hasPercent) {
					// 	strong.innerHTML += "%";
					// }
					item.classList.add("inited");
				}
			}
		);
	}

}